(function(root, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    root.PixelMobQuizDecision = api;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function() {
  function getBaseRecommendation(selectedCriteria) {
    return Array.isArray(selectedCriteria) && selectedCriteria.length > 0 ? 'pro' : 'standard';
  }

  function getViewVisibility(view) {
    return { resultHidden: view !== 'result' };
  }

  function getBackDestination(state) {
    if (state.stage === 'pro-gate') {
      return { stage: 'initial', index: 4 };
    }

    if (state.stage === 'pro-setup' && state.index === 0) {
      return { stage: 'pro-gate', index: 0 };
    }

    return { stage: state.stage, index: Math.max(0, state.index - 1) };
  }

  function shouldHideBack(state) {
    return state.stage === 'initial' && state.index === 0;
  }

  function getQuestionImage(images, stage, questionIndex, optionIndex) {
    if (!Array.isArray(images[questionIndex]) && !Array.isArray(images[5 + questionIndex])) return '';
    const row = stage === 'pro-setup' ? images[5 + questionIndex] : images[questionIndex];
    if (!Array.isArray(row)) return '';
    return row[optionIndex] || '';
  }

  function getResultKey(isSsd, isBattery) {
    if (isSsd && isBattery) return 'all';
    if (isSsd) return 'ssd';
    if (isBattery) return 'battery';
    return 'pro';
  }

  function getResultImage(images, resultKey) {
    if (!images) return '';
    const key = ['standard', 'pro', 'battery', 'ssd', 'all'].indexOf(resultKey) > -1 ? resultKey : 'pro';
    return images[key] || images.pro || '';
  }

  return { getBaseRecommendation, getViewVisibility, getBackDestination, shouldHideBack, getQuestionImage, getResultKey, getResultImage };
});
